var $ = require("jquery");

$(".preview form").submit(function (e) {
  e.preventDefault();
});
